import { LockClosedIcon } from '@heroicons/react/24/outline';

/**
 * The refusal screen, once.
 *
 * `RoleBasedRoute` and `ToolRoute` each carried their own copy — identical
 * markup, one word different in the sentence. Two copies of a refusal is two
 * places to fix when the wording is wrong, and the wording is the only part of
 * a refusal that does any work for the person reading it.
 *
 * `DepartmentRoute` deliberately does NOT use this. Its refusal names the team
 * you are on and links to your own workspace, which is a genuinely better answer
 * than "denied" — see the note in that file.
 */
export default function AccessDenied({ what = 'view this page' }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="h-14 w-14 rounded-2xl bg-error-500/20 flex items-center justify-center mb-4">
        <LockClosedIcon className="h-7 w-7 text-error-400" />
      </div>
      <h2 className="text-xl font-bold text-dark-900">Access denied</h2>
      <p className="text-surface-500 mt-1">You don’t have permission to {what}.</p>
    </div>
  );
}
